import type { WCallTranslations } from "./pl";

export const de: WCallTranslations = {
  widgetAriaLabel: "Hinterlassen Sie Ihre Nummer, wir rufen zurück",
  consultantAlt: "Berater",
  closeLabel: "Schließen",

  crmModeWithoutModule: {
    body1: "Das Fenster ist auf CRM-Versand konfiguriert, aber das Modul",
    moduleName: "m_crm_sales_support",
    body2:
      'ist in dieser Domain nicht aktiv. Aktiviere das Modul im Admin-Panel oder ändere den Versandmodus auf "E-Mail" in der Fenster-Konfiguration.',
  },
  unknownSendMode: (mode) =>
    `Unbekannter Versandmodus in der Fenster-Konfiguration: ${mode}.`,

  cta: {
    leaveNumber: "Nummer hinterlassen",
  },

  now: {
    title: "Kontaktieren Sie uns",
    intro:
      "Hinterlassen Sie Ihre Telefonnummer - unser Berater ruft so schnell wie möglich zurück.",
    btnNow: "Jetzt zurückrufen",
    btnLater: "Termin wählen",
  },

  later: {
    title: "Wählen Sie einen passenden Termin",
    intro: "Wählen Sie Tag und Uhrzeit - wir rufen zum gewünschten Termin zurück.",
    btnSubmit: "Anruf bestellen",
    btnBack: "Zurück",
  },

  labels: {
    telephone: "Telefon",
    day: "Tag",
    hour: "Uhrzeit",
  },

  placeholders: {
    selectDay: "Tag wählen",
    selectHour: "Uhrzeit wählen",
  },

  sending: "Wird gesendet...",

  validation: {
    requiredPhone: "Telefonnummer ist erforderlich.",
    invalidPhone: "Ungültige Telefonnummer.",
    requiredDay: "Wähle einen Tag.",
    invalidDay: "Ungültiger Tag.",
    requiredHour: "Wähle eine Uhrzeit.",
    invalidHour: "Ungültige Uhrzeit.",
  },

  status: {
    waitBeforeSubmit: (seconds) =>
      `Bitte warte noch ${seconds} Sekunden, bevor du absendest.`,
    rateLimit:
      "Zu viele Versuche von dieser IP-Adresse. Versuche es in Kürze erneut.",
    sendFailed: "Die Anfrage konnte nicht gespeichert werden.",
    sendSuccess: "Danke - wir rufen so schnell wie möglich zurück.",
    networkError: (message) => `Netzwerkfehler: ${message}`,
    networkErrorGeneric: "Netzwerkfehler beim Senden.",
  },
};
